export default __webpack_public_path__ + "static/media/up-chevron.c0aeb390.svg";